// ==========================================
// THE LAB — JS Global
// Se carga via snippet thelab-flow-detect.liquid en todas las páginas
// ==========================================

(function () {
  'use strict';

  // ----------------------------------------
  // 1. FIX VIEWPORT iOS Safari (--vh)
  // Corrige el bug donde 100vh incluye la barra de dirección en iOS
  // ----------------------------------------
  function setViewportHeight() {
    const vh = window.innerHeight * 0.01;
    document.documentElement.style.setProperty('--vh', `${vh}px`);
  }
  setViewportHeight();
  window.addEventListener('resize', setViewportHeight);
  window.addEventListener('orientationchange', function () {
    setTimeout(setViewportHeight, 100);
  });

  // ----------------------------------------
  // 2. SISTEMA DE DETECCIÓN DE FLUJO
  // Determina si el usuario está en lentes, vestuario o root
  // y aplica clases al body para controlar menú y switcher
  // ----------------------------------------
  const TheLab = {
    currentFlow: null,

    init: function () {
      this.detectFlow();
      this.applyFlowClasses();
      this.initSwitcher();
      this.initWishlist();
      this.initProductBadges();
    },

    // Lee el flujo detectado server-side por Liquid (inyectado como data attribute)
    // y como fallback usa sessionStorage para colecciones/productos sin sufijo claro
    detectFlow: function () {
      const serverFlow = document.documentElement.dataset.thelabServerFlow;

      if (serverFlow && serverFlow !== 'unknown') {
        if (serverFlow !== 'root') {
          this.currentFlow = serverFlow;
          sessionStorage.setItem('thelab_flow', serverFlow);
          localStorage.setItem('thelab_last_flow', serverFlow);
          return;
        }
        if (window.location.pathname !== '/') {
          const lastFlow = localStorage.getItem('thelab_last_flow');
          if (lastFlow) {
            this.currentFlow = lastFlow;
            return;
          }
        }
        this.currentFlow = 'root';
        return;
      }

      // Fallback para páginas de producto y colecciones no identificadas server-side
      const path = window.location.pathname;
      if (path.includes('/products/') || path.includes('/collections/')) {
        const saved = sessionStorage.getItem('thelab_flow');
        if (saved) {
          this.currentFlow = saved;
          return;
        }
      }

      // Root
      this.currentFlow = 'root';
    },

    applyFlowClasses: function () {
      const body = document.body;
      body.classList.remove(
        'thelab-flow-lentes',
        'thelab-flow-vestuario',
        'thelab-root-homepage'
      );

      if (this.currentFlow === 'lentes') {
        body.classList.add('thelab-flow-lentes');
      } else if (this.currentFlow === 'vestuario') {
        body.classList.add('thelab-flow-vestuario');
      } else if (window.location.pathname === '/' && window.thelabHideHomeChrome !== false) {
        body.classList.add('thelab-root-homepage');
      }
    },

    // Marca el tab activo en el switcher de header
    initSwitcher: function () {
      const switchers = document.querySelectorAll('.thelab-flow-switcher');
      switchers.forEach((switcher) => {
        const tabs = switcher.querySelectorAll('[data-flow]');
        tabs.forEach((tab) => {
          tab.classList.remove('is-active');
          tab.removeAttribute('aria-current');
          if (tab.dataset.flow === this.currentFlow) {
            tab.classList.add('is-active');
            tab.setAttribute('aria-current', 'page');
          }
        });
      });
    },

    // ----------------------------------------
    // 3. WISHLIST via localStorage
    // ----------------------------------------
    initWishlist: function () {
      const btns = document.querySelectorAll('[data-wishlist-toggle]');
      const wishlist = this.getWishlist();

      btns.forEach((btn) => {
        const id = btn.dataset.wishlistToggle;
        if (wishlist.includes(id)) {
          btn.classList.add('is-wishlisted');
          btn.setAttribute('aria-pressed', 'true');
        }

        btn.addEventListener('click', (e) => {
          e.preventDefault();
          this.toggleWishlist(id, btn);
        });
      });
    },

    getWishlist: function () {
      try {
        return JSON.parse(localStorage.getItem('thelab_wishlist') || '[]');
      } catch (e) {
        return [];
      }
    },

    toggleWishlist: function (productId, btn) {
      const wishlist = this.getWishlist();
      const idx = wishlist.indexOf(productId);

      if (idx === -1) {
        wishlist.push(productId);
        btn.classList.add('is-wishlisted');
        btn.setAttribute('aria-pressed', 'true');
      } else {
        wishlist.splice(idx, 1);
        btn.classList.remove('is-wishlisted');
        btn.setAttribute('aria-pressed', 'false');
      }

      localStorage.setItem('thelab_wishlist', JSON.stringify(wishlist));
    },

    // ----------------------------------------
    // 4. BADGES DE PRODUCTO
    // Lee data attributes inyectados por thelab-product-badge.liquid
    // ----------------------------------------
    initProductBadges: function () {
      // Los badges se renderizan server-side por Liquid, no necesitan JS
      // Este método está reservado para lógica de badge dinámica futura
    },
  };

  // Inicializar cuando el DOM esté listo
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => TheLab.init());
  } else {
    TheLab.init();
  }

  // Exponer globalmente para uso en otras secciones
  window.TheLab = TheLab;
})();
